import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';
import { useParams } from 'react-router-dom';

import { AddKeyPressHandler } from '@gem/keyboard-handler';

import { ChatBackground } from 'APP/main/components/ChatBackground/ChatBackground';
import { useChatBackgroundClassName } from 'APP/main/components/ChatBackground/hooks/useChatBackgroundClassName';

import { PinMessages } from '../Messages/PinMessages/PinMessages';
import { useAllPinsPresenter } from './AllPins.presenter';
import styles from './AllPins.styles.m.css';
import { AllPinsFooter } from './AllPinsFooter/AllPinsFooter';
import { AllPinsHeader } from './AllPinsHeader/AllPinsHeader';

export const AllPins: FC = observer(() => {
  const { id: groupId } = useParams<{ id: string }>();
  const presenter = useAllPinsPresenter(groupId);
  const chatBackgroundClassName = useChatBackgroundClassName();

  if (!groupId || !presenter.group) {
    return null;
  }

  return (
    <div className={classNames(styles.container, chatBackgroundClassName)}>
      <AddKeyPressHandler onEsc={presenter.onBack} />
      <ChatBackground />
      <AllPinsHeader groupId={groupId} />
      <PinMessages groupId={groupId} />
      <AllPinsFooter groupId={groupId} />
    </div>
  );
});
